/**
 * Floating contact buttons — sync state when mobile nav is open.
 */
const SELECTOR = '[data-contact-buttons]';
export function initContactButtons() {
    const root = document.querySelector(SELECTOR);
    if (!root) {
        return;
    }
    const syncNavOpen = () => {
        root.classList.toggle('contact-buttons--nav-open', document.body.classList.contains('mobile-nav-open'));
    };
    syncNavOpen();
    const observer = new MutationObserver(syncNavOpen);
    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
    });
}
